<template>
  <span class="text-nowrap">
    <span
      :class="innerNumberClass"
      :style="innerNumberStyle"
      data-testid="cancel-percentage"
    >
      {{ percentage }}
    </span>
    <span
      :class="innerUnitClass"
      :style="innerUnitStyle"
      data-testid="cancel-percentage-unit"
    >
      %
    </span>
  </span>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-facing-decorator";

@Component
export default class CancelPercentageBase extends Vue {
  @Prop({ required: false, type: Number }) yellowThreshold!: number;
  @Prop({ required: false, type: Number }) redThreshold!: number;
  @Prop({ required: true, type: Number }) percentage!: number;
  @Prop({ required: false, type: String }) numberSize?: string;
  @Prop({ required: false, type: String }) numberClass?: string;
  @Prop({ required: false, type: String }) unitSize?: string;
  @Prop({ required: false, type: String }) unitClass!: string;

  get innerNumberClass(): string {
    return this.numberClass
      ? `${this.colorClass} ${this.numberClass}`
      : this.colorClass;
  }

  get innerUnitClass(): string {
    return this.unitClass
      ? `${this.colorClass} ${this.unitClass}`
      : this.colorClass;
  }

  get innerUnitStyle(): Record<string, string> {
    return this.unitSize ? { fontSize: this.unitSize } : {};
  }

  get innerNumberStyle(): Record<string, string> {
    return this.numberSize ? { fontSize: this.numberSize } : {};
  }

  get colorClass(): string {
    if (this.percentage < this.yellowThreshold) {
      return "primary-dark";
    } else if (this.percentage < this.redThreshold) {
      return "text-yellow";
    }
    return "text-red";
  }
}
</script>
